class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.toggleDropdown();
    this.updatePlaceholder();
  }

  toggleDropdown() {
    const fieldSets = Array.from(this.querySelectorAll('fieldset'));

    fieldSets.map((fieldSet) => {
      const dropdownTrigger = fieldSet.querySelector('[data-variant-dropdown]');

      dropdownTrigger.addEventListener('click', function() {
        fieldSet.classList.toggle('swatches--active');
      })
    });
  }

  closeAll() {
    const fieldSets = Array.from(this.querySelectorAll('fieldset'));

    fieldSets.map((fieldSet) => fieldSet.classList.remove('swatches--active'));
  }

  updateVariantAvailability(variantAvailability) {
    const productStatus = document.querySelector('[data-product-stock]');

    productStatus.dataset.productStock = variantAvailability.available;
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.closeAll();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.dispatchVariantChange();
      this.updateVariantAvailability(this.currentVariant)
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  dispatchVariantChange() {
    document.dispatchEvent(
      new CustomEvent(
        'variant-change',
        {
          bubbles: true,
          variant: this.currentVariant,
          detail: {
            variant: this.currentVariant
          }
        }
      )
    );
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(() => { parent.scroll(0, 0) });
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="items"]');

      const newVariantInput = [
        {
          id: this.currentVariant.id,
          quantity: JSON.parse(input.value)[0].quantity
        }
      ];

      input.value = JSON.stringify(newVariantInput);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `#price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destinations = Array.from(document.querySelectorAll(id));
        const sources = html.querySelectorAll(id);

        destinations.forEach((destination, i) => {
          if (sources[i] && destination) destination.innerHTML = sources[i].innerHTML;
        })

        document.querySelectorAll(`#price-${this.dataset.section}`).forEach((price) => price?.classList.remove('visibility-hidden'));
        if (this.currentVariant) {
          this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        }
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButtons = document.querySelectorAll(`#product-form-${this.dataset.section}`);

    addButtons.forEach((addButton) => {
      if (!addButton?.querySelector('[name="add"]')) return;

      if (disable) {
        addButton.querySelector('[name="add"]').setAttribute('disabled', true);
        if (text) addButton.querySelector('[name="add"]').textContent = text;
      } else {
        addButton.querySelector('[name="add"]').removeAttribute('disabled');
        addButton.querySelector('[name="add"]').textContent = window.variantStrings.addToCart;
      }
    })

    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updatePlaceholder() {

    const variantOptions = Array.from(this.querySelectorAll('.swatches__label'));

    variantOptions.map((variantOption) => {
      variantOption.addEventListener('click', function() {
        const currentOption = this.textContent;
        const placeholder = this.closest('.swatches__wrapper').querySelector('[data-variant-placeholder]');

        placeholder.textContent = currentOption;
      })
    })

  }
}

if (!customElements.get('variant-selects')) {
  customElements.define('variant-selects', VariantSelects);
}

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

if (!customElements.get('variant-radios')) {
  customElements.define('variant-radios', VariantRadios);
}
